import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_accordion_496f1025__ from "@radix-ui/react-accordion";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__ from "@radix-ui/react-icons";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const Accordion = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_accordion_496f1025__.Root;
const AccordionItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_accordion_496f1025__.Item, {
        ref: ref,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-border-b", className),
        ...props
    }));
AccordionItem.displayName = "AccordionItem";
const AccordionTrigger = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_accordion_496f1025__.Header, {
        className: "tw-flex",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_accordion_496f1025__.Trigger, {
            ref: ref,
            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-flex tw-flex-1 tw-items-center tw-justify-between tw-py-4 tw-text-sm tw-font-medium tw-transition-all tw-hover:tw-underline [&[data-state=open]>svg]:tw-rotate-180", className),
            ...props,
            children: [
                children,
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__.ChevronDownIcon, {
                    className: "tw-h-4 tw-w-4 tw-shrink-0 tw-text-muted-foreground tw-transition-transform tw-duration-200"
                })
            ]
        })
    }));
AccordionTrigger.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_accordion_496f1025__.Trigger.displayName;
const AccordionContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_accordion_496f1025__.Content, {
        ref: ref,
        className: "tw-overflow-hidden tw-text-sm data-[state=closed]:tw-animate-accordion-up data-[state=open]:tw-animate-accordion-down",
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-pb-4 tw-pt-0", className),
            children: children
        })
    }));
AccordionContent.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_accordion_496f1025__.Content.displayName;
export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };

//# sourceMappingURL=accordion.mjs.map